import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Upload, Button, Icon, Spin, Radio, Input, DatePicker
} from 'antd'
import styled from "styled-components"
import { Link } from "react-router-dom"
import moment from 'moment'
import { withTranslation } from 'react-i18next';

const TemplateContainer = styled.div`
  background-color:#F8FAFB;
  padding: 20px;
  color:#999999;
`;

const TemplateDiv = styled.div`
  min-height: 100px;
`;

const TemplateLink = styled(Button)`
  margin-right:20px;
`;

const MyUpload = styled(Upload)`
  .ant-upload {
    margin-bottom:24px;
  }
  .ant-upload-list-item{
    margin-top:0;
    height:auto;
    background-color:#F8FAFB;
    padding:14px;
    cursor:pointer;
    color:#2FC29B;
    border-bottom:1px solid #eeeeee;
    .ant-upload-list-item-name{
      text-decoration:underline;
    }
    .ant-upload-list-item-info{
      background-color:inherit !important;
    }
  }
  .ant-upload-list-item-info .anticon-paper-clip,
  .ant-upload-list-item .anticon-close{
    margin-top:14px;
    margin-right:14px;
  }
`

class sendForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      template: '',
      loading: false,
      fileList: [],
      singelIMEI:'',
      radioValue: 1,
      hidden:{display:'none'},
    };
  }
  
  render() {    
    const { loading, fileList, radioValue,hidden } = this.state    
    const { t, type, title, template, defaultDate,singelValue,operator,curRoleId } = this.props
    const props = {
      name: 'file',
      accept: '.xls,.xlsx,.csv',
      beforeUpload: (file) => {
        this.setState(
          { fileList: [file] },
          () => {
            this.props.onChange(this.state.fileList[0])
          }
        )
        return false
      },
      onPreview(file) {
        var aLink = document.createElement('a')
        var blob = new Blob([file])
        aLink.download = file.name
        aLink.href = URL.createObjectURL(blob)
        aLink.click()
      },
      onRemove: () => {
        this.setState({ fileList: [] })
      },     
    }  
    const disabledDate = (current) => {
      return current < moment().startOf('day');
    } 
    return (
      <div>
        <div style={{ marginBottom: '10px' }}>
          <Radio.Group onChange={this.onChange} value={radioValue}>
            <Radio value={1}>Single</Radio>
            <Radio value={0}>Multiple</Radio>
          </Radio.Group>
        </div>
        { radioValue ? 
          <div>
            <Input value={singelValue} onChange={this.changeInput} placeholder='Please enter an IMEI' style={{marginBottom:'10px'}}></Input>
            {type === 4?<DatePicker disabledDate={disabledDate} allowClear={false} onChange={this.changeDate} defaultValue={defaultDate} style={{ marginBottom: '10px' }}></DatePicker>:''}
            
          </div>
          :
          <MyUpload {...props} fileList={fileList}>
            <div style={{ marginBottom: '10px' }}>
            <TemplateLink href={'/api/downloadTpl?type=' + (type === 4 ? 1 : 0)} onClick={(e) => { e.stopPropagation() }}>
              {t('Download Template(.xls)')}
            </TemplateLink>
            <TemplateLink href={'/api/downloadTpl?type=' + (type === 4 ? 3 : 2)} onClick={(e) => { e.stopPropagation() }}>
              {t('Download Template(.csv)')}
            </TemplateLink>
            </div>
            <Button type="primary">
              <Icon type="upload"></Icon>
              {t('Import IMEI')}
            </Button>
          </MyUpload>
        }       
        {        
         (type < 3 || type === 4  ) && (
            <TemplateContainer style={ operator === 'MYDG' ? hidden : null}>
              <Spin spinning={loading}>
                <TemplateDiv>{title}<br></br>{template}</TemplateDiv>
              </Spin>             
              { curRoleId ===1||curRoleId===2||curRoleId===3 ?
                <Link to="/notification_template">{t('Edit')}</Link>
              :
              ""
              }
            </TemplateContainer>
          )
        }
      </div>
    )
  }
  onChange = e => {    
    this.setState({radioValue: e.target.value});
    this.props.getRadioType(e.target.value)   
  };

  changeInput = e => {
    this.setState({singelIMEI: e.target.value});
    this.props.changeInput(e.target.value)   
  }

  changeDate = (value) => {   
    this.props.changeDate(value)  
  }
  
}

const mapStateToProps = (state) => {
  return {
    operator: state.operator,
    curRoleId:state.roleId,
  }
}

export default connect(mapStateToProps,null)(withTranslation()(sendForm))